var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn calendar-manager" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "date-selected" }, [
          _c("div", { staticClass: "text" }, [_vm._v("Date selected")]),
          _vm._v(" "),
          _c("div", { staticClass: "month-day" }, [
            _vm._v(
              _vm._s(_vm.today.format("MMMM")) +
                " " +
                _vm._s(_vm.today.date()) +
                " "
            ),
            _c("span", { staticClass: "year" }, [
              _vm._v(_vm._s(_vm.today.year()))
            ])
          ]),
          _vm._v(" "),
          _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) < 0
            ? _c("div", { staticClass: "date-status open" }, [_vm._v("open")])
            : _vm._e(),
          _vm._v(" "),
          _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) >= 0
            ? _c("div", { staticClass: "date-status blocked" }, [
                _vm._v("blocked")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-packing-slip-wrapper ap-btn primary",
              on: {
                click: function($event) {
                  _vm.downloadPackingSlip()
                }
              }
            },
            [_vm._v("\n          Create Packing Slip\n        ")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "calendar-and-event-container" }, [
      _c("div", { staticClass: "left-side" }, [
        _c(
          "div",
          [
            _c("div", { staticClass: "text-header" }, [
              _vm._v("\n            Calendar\n            "),
              _c(
                "button",
                {
                  staticClass: "today-btn ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.setToday()
                    }
                  }
                },
                [_vm._v("today")]
              )
            ]),
            _vm._v(" "),
            _c("CalendarDatePicker", {
              attrs: {
                showLeft: true,
                datesHasData: _vm.datesHasData,
                lockedDates: _vm.lockedDates,
                selectedDate: _vm.selectedDate,
                dateRangeHasData: _vm.dateRangeHasData
              },
              on: {
                input: _vm.selectDate,
                selectDate: _vm.setSelected,
                getDateRangeHasData: _vm.getDateRangeHasData
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "action-btn-panel" }, [
              _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) >= 0
                ? _c(
                    "button",
                    {
                      staticClass: "action-btn open ap-btn primary",
                      on: {
                        click: function($event) {
                          _vm.openSelectedDate()
                        }
                      }
                    },
                    [_vm._v("open date\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.lockedDates.indexOf(_vm.today.format("MM/DD/YYYY")) < 0
                ? _c(
                    "button",
                    {
                      staticClass: "action-btn block ap-btn destructive",
                      on: {
                        click: function($event) {
                          _vm.blockSelectedDate()
                        }
                      }
                    },
                    [_vm._v("block date\n            ")]
                  )
                : _vm._e()
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right-side" }, [
        _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass: "overlay",
                class: { isLoading: _vm.getLoading, noDisplay: !_vm.getLoading }
              },
              [
                _c(
                  "div",
                  { staticClass: "spinner-align" },
                  [
                    _c("Icon", {
                      staticClass: "icon-size",
                      attrs: { name: "spinner", scale: "5", pulse: "" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-header" }, [_vm._v("Events")]),
            _vm._v(" "),
            _vm.getTotalApprovedEvents == 0
              ? _c("div", { staticClass: "text-content" }, [
                  _vm._v(
                    "\n          No events found for the date selected\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.getEvents, function(item, index) {
              return [
                _c("div", { staticClass: "cheetah-digital" }, [
                  _c("span", [_vm._v(_vm._s(item.clientName))])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "event-cards-wrapper" },
                  _vm._l(item.events, function(event, index) {
                    return _c("EventCard", {
                      key: index,
                      attrs: { event: event, isNoTrans: index % 3 == 2 }
                    })
                  })
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clear-both" })
              ]
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44118e20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44118e20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manager/Calendar.vue
// module id = 1756
// module chunks = 1